import React from 'react';
import { AppIcon, IconName } from '../../../components/icons/AppIcon';
import { NUM_CLASS } from './DashboardCard';
import { cn } from '@/lib/utils';

interface StatCardProps {
  title: string;
  value: string;
  change: number;
  period: string;
  baseValue: string;
  icon: IconName;
  accent?: 'brand' | 'success';
}

const StatCard: React.FC<StatCardProps> = ({
  title, value, change, period, baseValue, icon, accent = 'brand',
}) => {
  const isPositive = change > 0;
  const isSuccess = accent === 'success';

  return (
    <article className="kpi-card min-w-0">
      <div className={isSuccess ? 'kpi-accent kpi-accent--success' : 'kpi-accent'} aria-hidden="true" />
      <header className="flex min-w-0 items-start justify-between gap-s2">
        <h3 className="kpi-label mb-s2 min-w-0 truncate">{title}</h3>
        <div
          className={`flex size-8 shrink-0 items-center justify-center rounded-lg ${
            isSuccess ? 'bg-success-bg text-success-text' : 'bg-brand-50 text-brand-600'
          }`}
          aria-hidden="true"
        >
          <AppIcon name={icon} className="size-4" />
        </div>
      </header>
      <p className={cn(NUM_CLASS, 'text-[22px] leading-tight text-primary md:text-[28px]')}>
        {value}
      </p>
      <footer className="kpi-footer">
        {change !== 0 && (
          <span className={`badge badge-sm ${isPositive ? 'badge-success' : 'badge-danger'}`}>
            {isPositive ? '+' : ''}{change.toFixed(1)}%
          </span>
        )}
        {baseValue !== '-' && (
          <span className="metric-footer truncate">
            {baseValue} {period}
          </span>
        )}
      </footer>
    </article>
  );
};

export default StatCard;
